import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import ManageUserSearchVM from "./ManageUserSearchVM";
import { fs } from "config/FsConfig";
import { Router } from 'aurelia-router';
import UserData01 from "../../../Core/Scripts/AppServiceContract/UserData01";
import ManageUserAppService from "../../Scripts/AppServiceContract/ManageUserAppService";

export default class ManageUserEditorVM extends EditorVMBase {
    Id: string;
    Code: string;
    Name: string;
    IsActive: boolean;
    router: Router;
    Email: string;

    constructor() {
        super();
        this.router = Container.instance.get(Router);
    }

    LoadOriginalSource(originalSource: UserData01) {
        this.Id = originalSource.UserUID;
        this.Code = originalSource.Code;
        this.Name = originalSource.Name;
        this.Email = originalSource.Email;
        this.IsActive = originalSource.IsActive;
    }
    SaveOriginalSource(originalSource: UserData01) {
        originalSource.UserUID = $.trim(this.Id);
        originalSource.Code = $.trim(this.Code);
        originalSource.Name = $.trim(this.Name);
        originalSource.Email = $.trim(this.Email);
        originalSource.IsActive = this.IsActive;

    }
    Remove(searchVM: ManageUserSearchVM, removeCallback: () => void) {
        var self = this;
        FsUtility.AlertModal("Are you sure you want to delete?", 3, 3, (result) => {
            if (result) {
                var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;
                service.Remove(self.Id)
                    .done((result) => {
                        FsUtility.AlertModal("The item has been updated successfully", 2, 1);
                        if (removeCallback != null)
                            removeCallback();
                    }).fail(FsUtility.CommonErrorHandler);
            }

        })
    }
    EditUserUrl(editorVM: ManageUserEditorVM) {
        var self = this;
      window.location.href = fs.Config.UserDetailUrl + editorVM.Id;
    }
}
